export default {"src":"/_next/static/media/ic-clear.7754e688.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};